/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  GenericSelectDataList
} from '../../model/genericSelectDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  InternalIntegrationTestingReportUpdateTableRetrieveParams
} from '../../model/internalIntegrationTestingReportUpdateTableRetrieveParams'
import type {
  TestingReportAPIData
} from '../../model/testingReportAPIData'
import type {
  TestingReportComparisonAPIData
} from '../../model/testingReportComparisonAPIData'
import type {
  TestingReportUpdateParamDataRequest
} from '../../model/testingReportUpdateParamDataRequest'
import type {
  TestingReportUpdateRequestDataRequest
} from '../../model/testingReportUpdateRequestDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets a table of previous testing reports for integration testing
 */
export const internalIntegrationTestingReportsTable = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-reports/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportsTableQueryKey = () => {
    return [`/integration-testing-reports/`] as const;
    }

    
export const getInternalIntegrationTestingReportsTableQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportsTableQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>> = ({ signal }) => internalIntegrationTestingReportsTable(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportsTableQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>>
export type InternalIntegrationTestingReportsTableQueryError = unknown

export const useInternalIntegrationTestingReportsTable = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportsTableQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportsTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportsTableQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>> = ({ signal }) => internalIntegrationTestingReportsTable(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportsTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>>
export type InternalIntegrationTestingReportsTableSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportsTableSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportsTableSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportsTableLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getInternalIntegrationTestingReportsTableQueryKey(),
          queryFn: () => internalIntegrationTestingReportsTable(),
        }).then(() => null));
      /**
 * Gets data for a specific integration testing report
 */
export const internalIntegrationTestingReportRetrieve = (
    testingReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TestingReportAPIData>(
      {url: `/integration-testing-reports/${testingReportId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportRetrieveQueryKey = (testingReportId: string,) => {
    return [`/integration-testing-reports/${testingReportId}/`] as const;
    }

    
export const getInternalIntegrationTestingReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportRetrieveQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>> = ({ signal }) => internalIntegrationTestingReportRetrieve(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>>
export type InternalIntegrationTestingReportRetrieveQueryError = unknown

export const useInternalIntegrationTestingReportRetrieve = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportRetrieveQueryOptions(testingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportRetrieveQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>> = ({ signal }) => internalIntegrationTestingReportRetrieve(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>>
export type InternalIntegrationTestingReportRetrieveSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportRetrieveSuspenseQueryOptions(testingReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ testingReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { testingReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (testingReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingReportRetrieveQueryKey(testingReportId),
              queryFn: () => internalIntegrationTestingReportRetrieve(testingReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets comparison data for a specific integration testing report and the previous one
 */
export const internalIntegrationTestingReportComparisonRetrieve = (
    testingReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TestingReportComparisonAPIData>(
      {url: `/integration-testing-reports/${testingReportId}/comparison/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportComparisonRetrieveQueryKey = (testingReportId: string,) => {
    return [`/integration-testing-reports/${testingReportId}/comparison/`] as const;
    }

    
export const getInternalIntegrationTestingReportComparisonRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportComparisonRetrieveQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>> = ({ signal }) => internalIntegrationTestingReportComparisonRetrieve(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportComparisonRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>>
export type InternalIntegrationTestingReportComparisonRetrieveQueryError = unknown

export const useInternalIntegrationTestingReportComparisonRetrieve = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportComparisonRetrieveQueryOptions(testingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportComparisonRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportComparisonRetrieveQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>> = ({ signal }) => internalIntegrationTestingReportComparisonRetrieve(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportComparisonRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>>
export type InternalIntegrationTestingReportComparisonRetrieveSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportComparisonRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportComparisonRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportComparisonRetrieveSuspenseQueryOptions(testingReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportComparisonRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ testingReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { testingReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (testingReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingReportComparisonRetrieveQueryKey(testingReportId),
              queryFn: () => internalIntegrationTestingReportComparisonRetrieve(testingReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets data comparison for feature flags a specific integration testing report to the previous
 */
export const internalIntegrationTestingReportFeatureFlagComparisonTable = (
    testingReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-reports/${testingReportId}/comparison-table-data/feature-flags/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportFeatureFlagComparisonTableQueryKey = (testingReportId: string,) => {
    return [`/integration-testing-reports/${testingReportId}/comparison-table-data/feature-flags/`] as const;
    }

    
export const getInternalIntegrationTestingReportFeatureFlagComparisonTableQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportFeatureFlagComparisonTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>> = ({ signal }) => internalIntegrationTestingReportFeatureFlagComparisonTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportFeatureFlagComparisonTableQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>>
export type InternalIntegrationTestingReportFeatureFlagComparisonTableQueryError = unknown

export const useInternalIntegrationTestingReportFeatureFlagComparisonTable = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportFeatureFlagComparisonTableQueryOptions(testingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportFeatureFlagComparisonTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportFeatureFlagComparisonTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>> = ({ signal }) => internalIntegrationTestingReportFeatureFlagComparisonTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportFeatureFlagComparisonTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>>
export type InternalIntegrationTestingReportFeatureFlagComparisonTableSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportFeatureFlagComparisonTableSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportFeatureFlagComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportFeatureFlagComparisonTableSuspenseQueryOptions(testingReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportFeatureFlagComparisonTableLoader = (paramsOrFn?: (Params | ((params: Params) => ({ testingReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { testingReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (testingReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingReportFeatureFlagComparisonTableQueryKey(testingReportId),
              queryFn: () => internalIntegrationTestingReportFeatureFlagComparisonTable(testingReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets git commit log data of changes since previous report.
 */
export const internalIntegrationTestingReportGitCommitComparisonTable = (
    testingReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-reports/${testingReportId}/comparison-table-data/git-commits/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportGitCommitComparisonTableQueryKey = (testingReportId: string,) => {
    return [`/integration-testing-reports/${testingReportId}/comparison-table-data/git-commits/`] as const;
    }

    
export const getInternalIntegrationTestingReportGitCommitComparisonTableQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportGitCommitComparisonTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>> = ({ signal }) => internalIntegrationTestingReportGitCommitComparisonTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportGitCommitComparisonTableQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>>
export type InternalIntegrationTestingReportGitCommitComparisonTableQueryError = unknown

export const useInternalIntegrationTestingReportGitCommitComparisonTable = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportGitCommitComparisonTableQueryOptions(testingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportGitCommitComparisonTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportGitCommitComparisonTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>> = ({ signal }) => internalIntegrationTestingReportGitCommitComparisonTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportGitCommitComparisonTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>>
export type InternalIntegrationTestingReportGitCommitComparisonTableSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportGitCommitComparisonTableSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportGitCommitComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportGitCommitComparisonTableSuspenseQueryOptions(testingReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportGitCommitComparisonTableLoader = (paramsOrFn?: (Params | ((params: Params) => ({ testingReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { testingReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (testingReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingReportGitCommitComparisonTableQueryKey(testingReportId),
              queryFn: () => internalIntegrationTestingReportGitCommitComparisonTable(testingReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets data comparison for tests for a specific integration testing report to the previous
 */
export const internalIntegrationTestingReportTestComparisonTable = (
    testingReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-reports/${testingReportId}/comparison-table-data/tests/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportTestComparisonTableQueryKey = (testingReportId: string,) => {
    return [`/integration-testing-reports/${testingReportId}/comparison-table-data/tests/`] as const;
    }

    
export const getInternalIntegrationTestingReportTestComparisonTableQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportTestComparisonTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>> = ({ signal }) => internalIntegrationTestingReportTestComparisonTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportTestComparisonTableQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>>
export type InternalIntegrationTestingReportTestComparisonTableQueryError = unknown

export const useInternalIntegrationTestingReportTestComparisonTable = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportTestComparisonTableQueryOptions(testingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportTestComparisonTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportTestComparisonTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>> = ({ signal }) => internalIntegrationTestingReportTestComparisonTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportTestComparisonTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>>
export type InternalIntegrationTestingReportTestComparisonTableSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportTestComparisonTableSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestComparisonTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportTestComparisonTableSuspenseQueryOptions(testingReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportTestComparisonTableLoader = (paramsOrFn?: (Params | ((params: Params) => ({ testingReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { testingReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (testingReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingReportTestComparisonTableQueryKey(testingReportId),
              queryFn: () => internalIntegrationTestingReportTestComparisonTable(testingReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a table of previous testing reports for integration testing
 */
export const internalIntegrationTestingReportTable = (
    testingReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-reports/${testingReportId}/table-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingReportTableQueryKey = (testingReportId: string,) => {
    return [`/integration-testing-reports/${testingReportId}/table-data/`] as const;
    }

    
export const getInternalIntegrationTestingReportTableQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>> = ({ signal }) => internalIntegrationTestingReportTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportTableQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>>
export type InternalIntegrationTestingReportTableQueryError = unknown

export const useInternalIntegrationTestingReportTable = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportTableQueryOptions(testingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingReportTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError = unknown>(testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingReportTableQueryKey(testingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>> = ({ signal }) => internalIntegrationTestingReportTable(testingReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(testingReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingReportTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>>
export type InternalIntegrationTestingReportTableSuspenseQueryError = unknown

export const useInternalIntegrationTestingReportTableSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError = unknown>(
 testingReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingReportTableSuspenseQueryOptions(testingReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingReportTableLoader = (paramsOrFn?: (Params | ((params: Params) => ({ testingReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { testingReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (testingReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingReportTableQueryKey(testingReportId),
              queryFn: () => internalIntegrationTestingReportTable(testingReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates the integration test expected data files for the specified customers
 */
export const internalIntegrationTestingFilesUpdate = (
    testingReportId: string,
    testingReportUpdateRequestDataRequest: TestingReportUpdateRequestDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/integration-testing-reports/${testingReportId}/update/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testingReportUpdateRequestDataRequest
    },
      options);
    }
  


export const getInternalIntegrationTestingFilesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingFilesUpdate>>, TError,{testingReportId: string;data: TestingReportUpdateRequestDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingFilesUpdate>>, TError,{testingReportId: string;data: TestingReportUpdateRequestDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingFilesUpdate>>, {testingReportId: string;data: TestingReportUpdateRequestDataRequest}> = (props) => {
          const {testingReportId,data} = props ?? {};

          return  internalIntegrationTestingFilesUpdate(testingReportId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingFilesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingFilesUpdate>>>
    export type InternalIntegrationTestingFilesUpdateMutationBody = TestingReportUpdateRequestDataRequest
    export type InternalIntegrationTestingFilesUpdateMutationError = unknown

    export const useInternalIntegrationTestingFilesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingFilesUpdate>>, TError,{testingReportId: string;data: TestingReportUpdateRequestDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingFilesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Lists the customer name options to update for an integration testing report
 */
export const internalIntegrationTestingReportCustomerNameUpdateOptions = (
    testingReportId: string,
    testingReportUpdateParamDataRequest: TestingReportUpdateParamDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/integration-testing-reports/${testingReportId}/update/options/customer-names/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testingReportUpdateParamDataRequest
    },
      options);
    }
  


export const getInternalIntegrationTestingReportCustomerNameUpdateOptionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportCustomerNameUpdateOptions>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportCustomerNameUpdateOptions>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportCustomerNameUpdateOptions>>, {testingReportId: string;data: TestingReportUpdateParamDataRequest}> = (props) => {
          const {testingReportId,data} = props ?? {};

          return  internalIntegrationTestingReportCustomerNameUpdateOptions(testingReportId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingReportCustomerNameUpdateOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportCustomerNameUpdateOptions>>>
    export type InternalIntegrationTestingReportCustomerNameUpdateOptionsMutationBody = TestingReportUpdateParamDataRequest
    export type InternalIntegrationTestingReportCustomerNameUpdateOptionsMutationError = unknown

    export const useInternalIntegrationTestingReportCustomerNameUpdateOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportCustomerNameUpdateOptions>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingReportCustomerNameUpdateOptionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Lists the test name options to update for an integration testing report
 */
export const internalIntegrationTestingReportTestNameUpdateOptions = (
    testingReportId: string,
    testingReportUpdateParamDataRequest: TestingReportUpdateParamDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/integration-testing-reports/${testingReportId}/update/options/test-names/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testingReportUpdateParamDataRequest
    },
      options);
    }
  


export const getInternalIntegrationTestingReportTestNameUpdateOptionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestNameUpdateOptions>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestNameUpdateOptions>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportTestNameUpdateOptions>>, {testingReportId: string;data: TestingReportUpdateParamDataRequest}> = (props) => {
          const {testingReportId,data} = props ?? {};

          return  internalIntegrationTestingReportTestNameUpdateOptions(testingReportId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingReportTestNameUpdateOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportTestNameUpdateOptions>>>
    export type InternalIntegrationTestingReportTestNameUpdateOptionsMutationBody = TestingReportUpdateParamDataRequest
    export type InternalIntegrationTestingReportTestNameUpdateOptionsMutationError = unknown

    export const useInternalIntegrationTestingReportTestNameUpdateOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportTestNameUpdateOptions>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingReportTestNameUpdateOptionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets the table showing the updates for a specific integration testing report
 */
export const internalIntegrationTestingReportUpdateTableRetrieve = (
    testingReportId: string,
    testingReportUpdateParamDataRequest: TestingReportUpdateParamDataRequest,
    params?: InternalIntegrationTestingReportUpdateTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/integration-testing-reports/${testingReportId}/update/table-data/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testingReportUpdateParamDataRequest,
        params
    },
      options);
    }
  


export const getInternalIntegrationTestingReportUpdateTableRetrieveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportUpdateTableRetrieve>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest;params?: InternalIntegrationTestingReportUpdateTableRetrieveParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportUpdateTableRetrieve>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest;params?: InternalIntegrationTestingReportUpdateTableRetrieveParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingReportUpdateTableRetrieve>>, {testingReportId: string;data: TestingReportUpdateParamDataRequest;params?: InternalIntegrationTestingReportUpdateTableRetrieveParams}> = (props) => {
          const {testingReportId,data,params} = props ?? {};

          return  internalIntegrationTestingReportUpdateTableRetrieve(testingReportId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingReportUpdateTableRetrieveMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingReportUpdateTableRetrieve>>>
    export type InternalIntegrationTestingReportUpdateTableRetrieveMutationBody = TestingReportUpdateParamDataRequest
    export type InternalIntegrationTestingReportUpdateTableRetrieveMutationError = unknown

    export const useInternalIntegrationTestingReportUpdateTableRetrieve = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingReportUpdateTableRetrieve>>, TError,{testingReportId: string;data: TestingReportUpdateParamDataRequest;params?: InternalIntegrationTestingReportUpdateTableRetrieveParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingReportUpdateTableRetrieveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    